// extracted by mini-css-extract-plugin
module.exports = {"container":"newBusinessInsightsMenu_container__3L39s","insightsList":"newBusinessInsightsMenu_insightsList__1PO1Z","active":"newBusinessInsightsMenu_active__1JALX"};